// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input-group__append-width-100 .el-input-group__append {\n  width: 80px;\n  left: -80px;\n}", ""]);
// Exports
module.exports = exports;
